/**
 * ============================================================================
 *                              crmss 版权声明
 * ============================================================================
 * 本软件系统（crmss - 快速开发通用管理后台框架）所有代码版权归 crmss 团队所有。
 * 代码中的 crmss 版权声明不允许删除和修改。
 * ============================================================================
 */
/**
 * JWT 格式校验工具（前端轻量校验，不解析内容）
 * 仅判断字符串是否符合 compact JWS 形态：header.payload.signature（恰好两个 '.'）
 * 用于在发请求前拦截 "null" / "undefined" / 损坏字符串被当成 token 发给后端
 */

/**
 * 后端既定的简易 token 前缀（非 JWT 格式，由 BrandPlatformAuthController /
 * StorePlatformAuthController 在登录时直接拼接 userId 生成）。
 * 后端 UserContextResolver / StoreController 等多个 Controller 都按这两种
 * 前缀解析 userId，等价于合法 token，前端不可拒发。
 */
const PLATFORM_TOKEN_PREFIXES = ['brand-platform-token-', 'store-platform-token-']

function isPlatformSimpleToken(token: string): boolean {
  for (const prefix of PLATFORM_TOKEN_PREFIXES) {
    if (token.startsWith(prefix)) {
      const idPart = token.slice(prefix.length)
      // userId 必须是非空数字串，防止 "brand-platform-token-" 这种空 id 脏数据通过
      return idPart.length > 0 && /^\d+$/.test(idPart)
    }
  }
  return false
}

/**
 * 判断字符串是否是合法 JWT compact JWS 格式
 * @param token 待校验的字符串
 * @returns 是否合法
 */
export function isValidJwtFormat(token: unknown): boolean {
  if (typeof token !== 'string') {
    return false
  }
  // 排除常见脏数据字符串
  if (token === 'null' || token === 'undefined' || token === 'false' || token === '0') {
    return false
  }
  // 兼容后端既定的简易 token 格式：brand-platform-token-{userId} / store-platform-token-{userId}
  if (isPlatformSimpleToken(token)) {
    return true
  }
  if (token.length < 16) {
    // 合法 JWT 至少 16 字符（3 段 Base64Url 各 5+ 字符）
    return false
  }
  // 必须恰好两个 '.'
  let dotCount = 0
  for (let i = 0; i < token.length; i++) {
    if (token[i] === '.') {
      dotCount++
    }
  }
  if (dotCount !== 2) {
    return false
  }
  // 每段必须非空
  const parts = token.split('.')
  return parts.length === 3 && parts[0].length > 0 && parts[1].length > 0 && parts[2].length > 0
}
